/**
 * Directive: viewMenu
 */
angular.module('acme.common.directive.viewMenu', [])
.directive('viewMenu', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/viewMenu/viewMenu.tpl.html',
      scope: {
        menuItems: '=menuitems'
      },
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function($scope) {

        $scope.viewMenu = {

          lastMenuIndex: -1,
          lastSubMenuIndex: -1,

          init: function() {
            this.checkSelected();
          },

          checkSelected: function() {
            var i, ii,
              j, jj;

            for (i = 0, ii = $scope.menuItems.length; i < ii; i++) {
              if ($scope.menuItems[i].selected) {
                this.lastMenuIndex = i;
              }
              if ($scope.menuItems[i].items instanceof Array) {
                for (j=0,jj=$scope.menuItems[i].items.length;j<jj;j++) {
                  if ($scope.menuItems[i].items[j].selected) {
                    this.lastMenuIndex = i;
                    this.lastSubMenuIndex = j;
                  }
                }
              }
            }
          },

          action: function(link, subLink) {
            var i, ii,
                j, jj;

            this.init();

            // If validation is required perform validation for links
            if (this.lastMenuIndex >= 0 &&
                $scope.menuItems[this.lastMenuIndex].hasOwnProperty('isValid') &&
                typeof($scope.menuItems[this.lastMenuIndex].isValid) === 'function' &&
                !$scope.menuItems[this.lastMenuIndex].isValid()) {
              return;
            }

            if (this.lastSubMenuIndex >= 0 &&
                $scope.menuItems[this.lastMenuIndex] &&
                $scope.menuItems[this.lastMenuIndex].hasOwnProperty('items') &&
                $scope.menuItems[this.lastMenuIndex].items instanceof Array &&
                $scope.menuItems[this.lastMenuIndex].items[this.lastSubMenuIndex].hasOwnProperty('isValid') &&
                typeof($scope.menuItems[this.lastMenuIndex].items[this.lastSubMenuIndex].isValid) === 'function' &&
                !$scope.menuItems[this.lastMenuIndex].items[this.lastSubMenuIndex].isValid()) {
              return;
            }


            for (i = 0, ii = $scope.menuItems.length; i < ii; i++) {
              $scope.menuItems[i].selected = false;
              if ($scope.menuItems[i].items instanceof Array) {
                for (j=0,jj=$scope.menuItems[i].items.length;j<jj;j++) {
                  $scope.menuItems[i].items[j].selected = false;
                }
              }
            }

            link.selected = true;
            link.action();

            if (subLink) {
              subLink.selected = true;
              subLink.action();
            }
          },

          select: function(index, subIndex) {
            var i, ii,
                j, jj;

            for (i=0,ii=$scope.menuItems.length;i<ii;i++) {
              $scope.menuItems[i].selected = (i === index);
              if (subIndex) {
                for (j=0,jj=$scope.menuItems[i].items;j<jj;j++) {
                  $scope.menuItems[i].items[j].selected = (j === subIndex);
                }
              }
            }
          }

        };

        $scope.viewMenu.init();

      }]

    };

}]);